export const movieCategories = [
  { id: "action", name: "动作片", slug: "action", icon: "ri-slideshow-line" },
  { id: "comedy", name: "喜剧片", slug: "comedy", icon: "ri-emotion-laugh-line" },
  { id: "romance", name: "爱情片", slug: "romance", icon: "ri-heart-line" },
  { id: "scifi", name: "科幻片", slug: "scifi", icon: "ri-rocket-line" },
  { id: "horror", name: "恐怖片", slug: "horror", icon: "ri-ghost-line" },
  { id: "animation", name: "动画片", slug: "animation", icon: "ri-palette-line" },
  { id: "documentary", name: "纪录片", slug: "documentary", icon: "ri-film-line" },
  { id: "war", name: "战争片", slug: "war", icon: "ri-sword-line" },
  { id: "suspense", name: "悬疑片", slug: "suspense", icon: "ri-search-eye-line" },
  { id: "crime", name: "犯罪片", slug: "crime", icon: "ri-police-car-line" },
];

export const featuredMovies = [
  {
    id: 1,
    title: "星际穿越",
    year: 2014,
    rating: 9.4,
    category: "科幻片",
    categorySlug: "scifi",
    duration: "169分钟",
    director: "克里斯托弗·诺兰",
    actors: ["马修·麦康纳", "安妮·海瑟薇", "杰西卡·查斯坦"],
    description: "一部探索人类生存与宇宙奥秘的史诗级科幻巨作，讲述了一组宇航员穿越虫洞，为人类寻找新家园的壮丽旅程。影片融合了前沿物理学理论与深沉的情感内核，展现了父女之间跨越时空的深厚情感。",
    posterUrl: "https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20poster%20with%20black%20hole%20and%20spacecraft%2C%20dark%20cosmic%20background%20with%20golden%20light%20rays%2C%20dramatic%20cinematic%20composition%2C%20deep%20space%20atmosphere%2C%20high%20contrast%2C%20mysterious%20and%20grand%2C%20warm%20amber%20highlights%20on%20deep%20black%20space%2C%20no%20text%2C%208k%20cinematic%20quality&width=600&height=900&seq=interstellar-poster&orientation=portrait",
  },
  {
    id: 2,
    title: "肖申克的救赎",
    year: 1994,
    rating: 9.7,
    category: "犯罪片",
    categorySlug: "crime",
    duration: "142分钟",
    director: "弗兰克·德拉邦特",
    actors: ["蒂姆·罗宾斯", "摩根·弗里曼"],
    description: "改编自斯蒂芬·金同名小说，讲述银行家安迪因被误判杀害妻子及其情人而入狱，在肖申克监狱中凭借才智和毅力，最终重获自由的故事。影片深刻诠释了希望与坚持的力量。",
    posterUrl: "https://readdy.ai/api/search-image?query=Classic%20prison%20drama%20movie%20poster%20style%2C%20warm%20golden%20sunset%20light%20breaking%20through%20dark%20stone%20walls%2C%20silhouette%20of%20a%20man%20standing%20in%20rain%20looking%20up%2C%20hope%20and%20redemption%20theme%2C%20cinematic%20lighting%20with%20strong%20contrast%2C%20emotional%20and%20powerful%20atmosphere%2C%20deep%20charcoal%20background%20with%20warm%20amber%20rays%2C%20no%20text%2C%208k%20film%20grain%20quality&width=600&height=900&seq=shawshank-poster&orientation=portrait",
  },
  {
    id: 3,
    title: "盗梦空间",
    year: 2010,
    rating: 9.3,
    category: "科幻片",
    categorySlug: "scifi",
    duration: "148分钟",
    director: "克里斯托弗·诺兰",
    actors: ["莱昂纳多·迪卡普里奥", "约瑟夫·戈登-莱维特", "艾伦·佩吉"],
    description: "一部关于梦境入侵的科幻惊悚片，讲述专业窃贼柯布通过潜入他人梦境窃取机密，被赋予一项看似不可能的任务——在目标潜意识中植入一个想法。影片以其复杂的叙事结构和惊人的视觉效果闻名。",
    posterUrl: "https://readdy.ai/api/search-image?query=Mind-bending%20sci-fi%20thriller%20movie%20poster%2C%20surreal%20cityscape%20folding%20upon%20itself%20with%20floating%20architectural%20fragments%2C%20deep%20navy%20and%20charcoal%20tones%20with%20warm%20golden%20accents%2C%20dreamlike%20atmosphere%20with%20layered%20dimensional%20effects%2C%20abstract%20geometric%20patterns%2C%20cinematic%20and%20mysterious%2C%20no%20text%2C%208k%20surreal%20quality&width=600&height=900&seq=inception-poster&orientation=portrait",
  },
  {
    id: 4,
    title: "泰坦尼克号",
    year: 1997,
    rating: 9.4,
    category: "爱情片",
    categorySlug: "romance",
    duration: "194分钟",
    director: "詹姆斯·卡梅隆",
    actors: ["莱昂纳多·迪卡普里奥", "凯特·温斯莱特"],
    description: "以1912年泰坦尼克号邮轮沉没事件为背景，讲述了穷画家杰克和贵族少女露丝跨越阶级的爱情故事。影片将宏大的历史灾难与细腻的爱情叙事完美结合，成为影史经典。",
    posterUrl: "https://readdy.ai/api/search-image?query=Romantic%20epic%20movie%20poster%2C%20couple%20embracing%20on%20ship%20bow%20against%20dramatic%20sunset%20sky%2C%20golden%20and%20amber%20warm%20tones%20with%20deep%20ocean%20blue%20contrast%2C%20romantic%20and%20grand%20atmosphere%2C%20cinematic%20composition%20with%20soft%20glowing%20light%2C%20nostalgic%20vintage%20film%20aesthetic%2C%20no%20text%2C%208k%20cinematic%20quality&width=600&height=900&seq=titanic-poster&orientation=portrait",
  },
  {
    id: 5,
    title: "千与千寻",
    year: 2001,
    rating: 9.4,
    category: "动画片",
    categorySlug: "animation",
    duration: "125分钟",
    director: "宫崎骏",
    actors: ["柊瑠美", "入野自由"],
    description: "宫崎骏执导的动画经典，讲述少女千寻意外进入神灵世界后，为了拯救变成猪的父母，在白龙的帮助下在汤屋工作的冒险故事。影片充满奇幻想象力与深刻寓意。",
    posterUrl: "https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20movie%20poster%2C%20young%20girl%20walking%20through%20mystical%20spirit%20world%20with%20traditional%20bathhouse%20architecture%2C%20soft%20warm%20lantern%20light%2C%20magical%20floating%20spirits%20and%20creatures%2C%20rich%20traditional%20colors%20of%20vermillion%20red%20and%20gold%2C%20dreamlike%20fantasy%20atmosphere%2C%20hand-drawn%20artistic%20quality%2C%20no%20text%2C%208k%20illustrative%20style&width=600&height=900&seq=spirited-away-poster&orientation=portrait",
  },
  {
    id: 6,
    title: "这个杀手不太冷",
    year: 1994,
    rating: 9.4,
    category: "动作片",
    categorySlug: "action",
    duration: "110分钟",
    director: "吕克·贝松",
    actors: ["让·雷诺", "娜塔莉·波特曼", "加里·奥德曼"],
    description: "讲述职业杀手里昂在救下邻家女孩玛蒂尔达后，两人之间发展出的温情羁绊。影片将冷酷的杀手世界与纯真的情感完美融合，成为动作电影中的经典之作。",
    posterUrl: "https://readdy.ai/api/search-image?query=Stylish%20action%20thriller%20movie%20poster%2C%20lone%20figure%20in%20long%20coat%20walking%20on%20dimly%20lit%20urban%20street%2C%20moody%20cinematic%20lighting%20with%20deep%20shadows%20and%20warm%20amber%20street%20lamp%20glow%2C%20melancholic%20and%20cool%20atmosphere%2C%20film%20noir%20inspired%20composition%2C%20dark%20charcoal%20background%20with%20isolated%20warm%20light%2C%20no%20text%2C%208k%20cinematic%20grain%20quality&width=600&height=900&seq=leon-poster&orientation=portrait",
  },
];

export const latestMovies = [
  {
    id: 7,
    title: "流浪地球3",
    year: 2026,
    rating: 8.8,
    category: "科幻片",
    categorySlug: "scifi",
    duration: "156分钟",
    director: "郭帆",
    actors: ["吴京", "刘德华", "李雪健"],
    description: "延续前作宏大叙事，人类在流浪地球计划持续推进中面临新的危机与抉择，展现了人类文明在绝境中求生的顽强意志与团结精神。视觉特效全面升级，打造中国科幻新高度。",
    posterUrl: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20sci-fi%20movie%20poster%2C%20massive%20planetary%20engines%20firing%20against%20dark%20space%20background%2C%20Earth%20with%20glowing%20blue%20thrust%20trails%2C%20dramatic%20scale%20and%20grandeur%2C%20deep%20space%20with%20warm%20orange%20engine%20glow%20contrast%2C%20futuristic%20and%20awe-inspiring%2C%20cinematic%20wide%20composition%2C%20no%20text%2C%208k%20hyperrealistic%20quality&width=600&height=900&seq=wandering-earth-3-poster&orientation=portrait",
  },
  {
    id: 8,
    title: "封神第二部",
    year: 2026,
    rating: 8.6,
    category: "动作片",
    categorySlug: "action",
    duration: "148分钟",
    director: "乌尔善",
    actors: ["费翔", "黄渤", "于适"],
    description: "中国神话史诗巨制续作，继续讲述商周交替之际的神话传奇，诸神之战全面展开，视觉奇观与中国传统文化元素深度融合，打造震撼人心的东方奇幻世界。",
    posterUrl: "https://readdy.ai/api/search-image?query=Chinese%20mythological%20epic%20movie%20poster%2C%20ancient%20warriors%20in%20ornate%20armor%20battling%20mythical%20beasts%2C%20dramatic%20stormy%20sky%20with%20divine%20light%20breaking%20through%20clouds%2C%20traditional%20Chinese%20red%20and%20gold%20color%20palette%2C%20grand%20epic%20scale%2C%20dynamic%20combat%20composition%2C%20mystical%20and%20powerful%20atmosphere%2C%20no%20text%2C%208k%20cinematic%20quality&width=600&height=900&seq=fengshen-2-poster&orientation=portrait",
  },
  {
    id: 9,
    title: "奥本海默",
    year: 2023,
    rating: 8.8,
    category: "纪录片",
    categorySlug: "documentary",
    duration: "180分钟",
    director: "克里斯托弗·诺兰",
    actors: ["基里安·墨菲", "艾米莉·布朗特", "马特·达蒙"],
    description: "讲述原子弹之父罗伯特·奥本海默的传奇人生，从曼哈顿计划到战后的道德困境，影片以诺兰标志性的非线性叙事，深度探讨科学、权力与良知之间的复杂关系。",
    posterUrl: "https://readdy.ai/api/search-image?query=Intense%20biographical%20drama%20movie%20poster%2C%20lone%20figure%20silhouetted%20against%20nuclear%20explosion%20mushroom%20cloud%2C%20stark%20black%20and%20white%20with%20warm%20fiery%20orange%20center%2C%20dramatic%20contrast%2C%20philosophical%20and%20heavy%20atmosphere%2C%20documentary%20realism%20style%2C%20grainy%20film%20texture%2C%20no%20text%2C%208k%20cinematic%20quality&width=600&height=900&seq=oppenheimer-poster&orientation=portrait",
  },
  {
    id: 10,
    title: "热辣滚烫",
    year: 2024,
    rating: 8.2,
    category: "喜剧片",
    categorySlug: "comedy",
    duration: "129分钟",
    director: "贾玲",
    actors: ["贾玲", "雷佳音", "张小斐"],
    description: "讲述一位平凡女性通过拳击运动重新找回自我、实现人生蜕变的励志喜剧故事。影片以温暖幽默的方式探讨自我认同与成长，笑中带泪，鼓舞人心。",
    posterUrl: "https://readdy.ai/api/search-image?query=Inspiring%20sports%20comedy%20movie%20poster%2C%20woman%20in%20boxing%20gloves%20standing%20confidently%20in%20gym%2C%20warm%20golden%20sunlight%20streaming%20through%20windows%2C%20motivational%20and%20uplifting%20atmosphere%2C%20soft%20cinematic%20lighting%2C%20warm%20amber%20and%20cream%20tones%2C%20empowering%20and%20joyful%20mood%2C%20no%20text%2C%208k%20cinematic%20quality&width=600&height=900&seq=hot-spicy-poster&orientation=portrait",
  },
  {
    id: 11,
    title: "死侍与金刚狼",
    year: 2024,
    rating: 8.0,
    category: "动作片",
    categorySlug: "action",
    duration: "127分钟",
    director: "肖恩·利维",
    actors: ["瑞安·雷诺兹", "休·杰克曼"],
    description: "漫威宇宙最不正经的超级英雄死侍与传奇金刚狼首次联手，穿越多元宇宙展开一场疯狂搞笑的冒险。影片融合极致动作与无厘头幽默，带来全新超级英雄体验。",
    posterUrl: "https://readdy.ai/api/search-image?query=Action%20comedy%20superhero%20movie%20poster%2C%20two%20contrasting%20antiheroes%20standing%20back%20to%20back%20in%20dynamic%20pose%2C%20urban%20cityscape%20at%20dusk%20with%20neon%20accents%2C%20red%20and%20yellow%20costume%20contrast%20against%20dark%20background%2C%20edgy%20and%20humorous%20atmosphere%2C%20comic%20book%20inspired%20composition%2C%20no%20text%2C%208k%20cinematic%20quality&width=600&height=900&seq=deadpool-wolverine-poster&orientation=portrait",
  },
  {
    id: 12,
    title: "周处除三害",
    year: 2024,
    rating: 8.4,
    category: "犯罪片",
    categorySlug: "crime",
    duration: "134分钟",
    director: "黄精甫",
    actors: ["阮经天", "袁富华", "陈以文"],
    description: "改编自中国古典典故，将古代传奇移植到现代黑帮世界。一名通缉犯决定在自首前除掉排名在自己之前的两个通缉犯，展开一场充满黑色幽默与暴力美学的赎罪之旅。",
    posterUrl: "https://readdy.ai/api/search-image?query=Dark%20crime%20thriller%20movie%20poster%2C%20lone%20man%20in%20black%20suit%20standing%20under%20neon-lit%20night%20street%20in%20Taipei%2C%20rain-soaked%20pavement%20reflecting%20colorful%20lights%2C%20noir%20atmosphere%20with%20deep%20shadows%2C%20red%20and%20cyan%20neon%20contrast%20against%20dark%20background%2C%20stylish%20and%20intense%2C%20no%20text%2C%208k%20cinematic%20quality&width=600&height=900&seq=zhou-chu-poster&orientation=portrait",
  },
];

export const trendingMovies = [
  {
    id: 13,
    title: "沙丘2",
    year: 2024,
    rating: 8.5,
    category: "科幻片",
    categorySlug: "scifi",
    duration: "166分钟",
    director: "丹尼斯·维伦纽瓦",
    actors: ["提莫西·查拉梅", "赞达亚", "丽贝卡·弗格森"],
    description: "史诗科幻续作，保罗·厄崔迪斯与弗雷曼人联手，踏上向毁灭他家族的阴谋者复仇的征程，同时面临在挚爱与宇宙命运之间做出抉择的困境。",
    posterUrl: "https://readdy.ai/api/search-image?query=Epic%20sci-fi%20desert%20planet%20movie%20poster%2C%20lone%20warrior%20standing%20on%20massive%20sand%20dune%20overlooking%20vast%20desert%20landscape%2C%20warm%20golden%20sand%20tones%20against%20deep%20amber%20sky%2C%20monumental%20scale%20and%20grandeur%2C%20cinematic%20wide%20composition%2C%20mystical%20and%20powerful%20atmosphere%20with%20dust%20particles%20in%20light%2C%20no%20text%2C%208k%20cinematic%20quality&width=600&height=900&seq=dune-2-poster&orientation=portrait",
  },
  {
    id: 14,
    title: "你想活出怎样的人生",
    year: 2024,
    rating: 8.3,
    category: "动画片",
    categorySlug: "animation",
    duration: "124分钟",
    director: "宫崎骏",
    actors: ["山时聪真", "菅田将晖", "木村拓哉"],
    description: "宫崎骏最新力作，讲述少年真人在母亲去世后，跟随一只会说话的苍鹭进入神秘塔楼，展开一段关于生命、死亡与成长的奇幻冒险。",
    posterUrl: "https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20movie%20poster%2C%20young%20boy%20standing%20before%20mysterious%20ancient%20tower%20with%20heron%20bird%2C%20soft%20watercolor%20wash%20background%20in%20muted%20earth%20tones%2C%20dreamlike%20and%20nostalgic%20atmosphere%2C%20hand-drawn%20artistic%20quality%20with%20gentle%20lighting%2C%20whimsical%20and%20contemplative%20mood%2C%20no%20text%2C%208k%20illustrative%20style&width=600&height=900&seq=boy-heron-poster&orientation=portrait",
  },
  {
    id: 15,
    title: "年会不能停！",
    year: 2024,
    rating: 8.1,
    category: "喜剧片",
    categorySlug: "comedy",
    duration: "117分钟",
    director: "董润年",
    actors: ["大鹏", "白客", "庄达菲"],
    description: "一部反映当代职场生态的讽刺喜剧，讲述一名普通职员因年会节目意外走红，引发一系列啼笑皆非的连锁反应，深刻揭露职场文化中的荒诞与现实。",
    posterUrl: "https://readdy.ai/api/search-image?query=Chinese%20workplace%20comedy%20movie%20poster%2C%20group%20of%20office%20workers%20in%20formal%20attire%20in%20chaotic%20funny%20pose%2C%20bright%20modern%20office%20background%20with%20colorful%20party%20decorations%2C%20vibrant%20and%20humorous%20atmosphere%2C%20warm%20indoor%20lighting%2C%20energetic%20and%20lively%20composition%2C%20no%20text%2C%208k%20cinematic%20quality&width=600&height=900&seq=nianhui-poster&orientation=portrait",
  },
  {
    id: 16,
    title: "首尔之春",
    year: 2024,
    rating: 8.7,
    category: "战争片",
    categorySlug: "war",
    duration: "141分钟",
    director: "金成洙",
    actors: ["黄政民", "郑雨盛", "李星民"],
    description: "改编自真实历史事件，讲述1979年韩国政治动荡时期，权力真空下各方势力角逐的惊心动魄故事。影片以紧张的政治博弈和人物命运交织，展现历史转折时刻的人性。",
    posterUrl: "https://readdy.ai/api/search-image?query=Korean%20historical%20political%20thriller%20movie%20poster%2C%20military%20officers%20in%20tense%20confrontation%20in%20dimly%20lit%20government%20building%20corridor%2C%20cold%20winter%20atmosphere%20with%20muted%20gray%20and%20dark%20tones%2C%20dramatic%20shadows%20and%20stark%20lighting%2C%20intense%20and%20suspenseful%20composition%2C%20no%20text%2C%208k%20cinematic%20quality&width=600&height=900&seq=seoul-spring-poster&orientation=portrait",
  },
];

export const allMovies = [...featuredMovies, ...latestMovies, ...trendingMovies];